<style scoped>
    .staff-card{
        display: inline-block;
        vertical-align: top;
        width: 200px;
        border: 1px solid #dddee1;
        text-align: left;
        padding: 5px;
        background-color: white;
        transition: .4s;
    }
    .staff-card:hover{
        box-shadow: 0 1px 3px rgba(55,55,55,.3);
        transform: scale(1.05,1.05);
    }
    .avatar-wrap{
        position: relative;
        line-height: 1;
        border: 1px solid #dddee1;
        max-height: 200px;
        overflow: hidden;
    }
    .avatar{
        display: block;
        width: 100%;
    }
    .qq-wrap{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,.8);
        padding: 10px;
        /*color: white;*/
        font-weight: bold;
    }
    .qq-link{
        color: #2d8cf6;
        text-decoration: underline;
    }
    .qq-link:hover{
        color: #2d8cf6;
    }
    .name{
        margin-top: 5px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }
    .duty, .contact, .time{
        margin-top: 2px;
    }
    .wechat-text{
        cursor: pointer;
        color: #2d8cf6;
    }
    .wechat-image-wrap img{
        width: 100%;
    }
    .staff-card /deep/ .ivu-poptip-body-content{
        max-height: 1000px;
    }
</style>
<template>
    <div class="staff-card">
        <div class="avatar-wrap">
            <img class="avatar" :src="avatar_src">
            <div class="qq-wrap" v-if="staff.qq">
                <span>QQ/TIM: </span>
                <a class="qq-link" target="_blank" :href="qq_href"><Icon type="chatboxes"></Icon> 立即联系</a>
            </div>
        </div>
        <div class="name">
            <span>{{staff.name}}</span>
            <span v-if="staff.nickname">({{staff.nickname}})</span>
        </div>
        <div class="duty" :style="duty_style">
            <h4>负责事项:</h4>
            <div v-html="staff.duty"></div>
        </div>
        <div class="time" v-if="staff.time">
            <span class="text-bold">专属答疑时间: </span><span>{{staff.time}}</span>
        </div>
        <div class="contact">
            <h4>联系方式:</h4>
            <div v-if="staff.email">
                <span>邮箱: </span>
                <a class="link" :href="email_href">{{staff.email}}</a>
            </div>
            <div v-if="staff.mobile">
                <span>电话: </span>
                <span class="link">{{staff.mobile}}</span>
            </div>
            <Poptip popper-class="staff-card-wechat" placement="bottom" trigger="hover" width="200" v-if="staff.wechat_image">
                <span class="wechat-text">添加<span v-if="is_wx_work">企业</span>微信</span>
                <div class="wechat-image-wrap" slot="content">
                    <img :src="wechat_src">
                </div>
            </Poptip>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            staff: {
                type: Object
            },
            duty_height: {
                type: Number,
                default: 72
            },
            is_wx_work: {
                type: Boolean,
                default: false,
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            avatar_src(){
                //return this.staff.avatar ? `/static/fin_staff_avatar/${this.staff.avatar}` : '';
                return this.staff.avatar ? Util.publicOSSUrl(this.staff.avatar) + '?x-oss-process=style/preview' : '';
            },
            email_href(){
                return `mailto:${this.staff.email}`
            },
            qq_href(){
                return  `http://wpa.qq.com/msgrd?v=3&uin=${this.staff.qq}&site=qq&menu=yes`;
            },
            wechat_src(){
                // return `/static/fin_staff_wechat/${this.staff.wechat_image}`;
                return this.staff.wechat_image ? Util.publicOSSUrl(this.staff.wechat_image) + '?x-oss-process=style/preview' : '';
            },
            duty_style(){
                return {
                    minHeight: `${this.duty_height}px`
                }
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            //
        }
    }
</script>
